export default __webpack_public_path__ + "static/media/JSweather.adc8a0d9.png";